import gql from 'graphql-tag';

const mutation = gql`
  mutation checkoutCart(
    $jsonCart: String!
    $clientMutationId: String
    $emailId: String
  ) {
    checkoutCart(
      input: {
        jsonCart: $jsonCart
        clientMutationId: $clientMutationId
        emailId: $emailId
      }
    ) {
      success
      clientMutationId
      errors
    }
  }
`;

export default function checkoutCart({
  apollo,
  jsonCart,
  clientMutationId,
  emailId
}) {
  return apollo.mutate({
    mutation,
    variables: {
      jsonCart,
      clientMutationId,
      emailId
    }
  });
}
